import axios from 'axios';

const API_BASE_URL = process.env.NODE_ENV === 'development' 
  ? 'http://localhost:3001/api'
  : 'https://'; // Replace with your production API URL when deployed

export async function findLiveNationVenuePhoto(venueName, city, state) {
  try {
    const response = await axios.post(`${API_BASE_URL}/venues/photos`, {
      venueName,
      city,
      state
    });

    if (response.data.photos && response.data.photos.length > 0) {
      return response.data.photos[0];
    }

    return null;
  } catch (error) {
    console.error('Error fetching venue photo:', error);
    if (error.response?.status === 429) {
      throw new Error('Rate limit exceeded. Please try again later.');
    }
    if (error.response?.status === 503) {
      throw new Error('Photo service is temporarily unavailable.');
    }
    throw new Error('Failed to fetch venue photo');
  }
} 